<template lang="pug">
  v-flex.container(v-if="config")
    .title Configuration
    div.configuration
      label.v-label.grey--text.invert-title Afficher la légende
      v-checkbox.checkbox(
        :input-value="config.legend?config.legend.state:false"
        color="primary"
        @change="activateOrDeactivateLegend"
      )
      label.v-label.grey--text.invert-title Position en bas à droite
      v-checkbox.checkbox(
        :input-value="config.legend?(config.legend.position==='bottomright'):false"
        color="primary"
        @change="switchPositionOfLegend"
      )

    .title Éléments de légende
    v-layout.column.margin
      div.property(v-if="config.legend.data" v-for="(property,idx) of config.legend.data")
        rc-color-picker(
          popup="top"
          :color="property.color"
          @changeColor="value => updateColor(value, idx)"
        )
        v-text-field(label="Nom" :value="property.name" @change="value => updateName(value,idx)")
        v-icon(@click="deleteProperty(idx)") delete
      v-icon.add(@click="addProperty()" title="Ajouter un élément") add
</template>

<script>
import RcColorPicker from '@/components/RcColorPicker.vue';
import mixin from '@/mixins/Rc.mixin.vue';
import Vue from 'vue';

export default {
  name: 'RcLegendEdit',
  components: {
    RcColorPicker,
  },
  mixins: [mixin],
  props: {
    config: Object,
  },
  data() {
    return {};
  },
  computed: {
    legendData: {
      get() {
        return this.config.legend.data;
      },
      set(data) {
        console.log(data);
        this.config.legend.data = data;
      },
    },
  },
  methods: {
    activateOrDeactivateLegend() {
      this.config.legend.state = !(this.config.legend && this.config.legend.state);
      this.$emit('changed', this.filterConfig(this.config));
    },
    switchPositionOfLegend() {
      if (this.config.legend.position === 'bottomright') this.config.legend.position = 'bottomleft';
      else this.config.legend.position = 'bottomright';
      this.$emit('changed', this.filterConfig(this.config));
    },
    updateColor(color, index) {
      this.config.legend.data[index].color = color;
      this.$emit('changed', this.filterConfig(this.config));
    },
    updateName(name, index) {
      this.config.legend.data[index].name = name;
      this.$emit('changed', this.filterConfig(this.config));
    },
    addProperty() {
      if (this.config.legend.data) this.config.legend.data.push({ name: '', color: this.defaultColor });
      else Vue.set(this.config.legend, 'data', [{ name: '', color: this.defaultColor }]);
    },
    deleteProperty(index) {
      this.config.legend.data.splice(index, 1);
      this.$emit('changed', this.filterConfig(this.config));
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0.5em 1em 0 1em;

  .title {
    margin-top: 0.5em;
  }

  .configuration {
    display: grid;
    grid-template: auto / 1fr auto;
    row-gap: 0.5em;
    margin: 1.5em 6em 2em 2em;

    .checkbox {
      margin-top: 0;
    }
  }

  .property {
    align-items: center;
    display: grid;
    grid-template: auto / 3fr 5fr auto;

    i {
      margin-left: 0.5em;
    }
  }
  .add {
    border: 1px grey solid;
    border-radius: 50%;
    max-width: fit-content;
    align-self: center;
    margin-top: 0.25em;
    margin-bottom: 1em;

    &:hover {
      border-color: #e7523e;
    }
  }
}
</style>
